module.exports = __webpack_public_path__ + "img/wallet-order-message.94ec870c.svg";